import React from 'react';

import { GatsbyRoot } from '@/lib/gatsby';
import { MessagingRates } from '../subcomponents/checkout/static_pages/MessagingRates';

export default () => (
  <GatsbyRoot>
    <MessagingRates />
  </GatsbyRoot>
);
